module.exports = __webpack_public_path__ + "static/media/magzineSub.e8a98fae.jpg";